
      export default {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"xmlns":"http://www.w3.org/2000/svg","viewBox":"0 0 20 20"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"d":"M20 4.5v12c0 .827-.673 1.5-1.5 1.5h-10c-.827 0-1.5-.673-1.5-1.5v-4a.5.5 0 0 1 1 0v4a.5.5 0 0 0 .5.5h10a.5.5 0 0 0 .5-.5v-12a.5.5 0 0 0-.5-.5h-10a.5.5 0 0 0-.5.5v4a.5.5 0 0 1-1 0v-4C7 3.673 7.673 3 8.5 3h10c.827 0 1.5.673 1.5 1.5z"}}),_c('path',{attrs:{"d":"M3.646 7.147l-3 3a.5.5 0 0 0 0 .707l3 3a.5.5 0 0 0 .707-.707L2.207 11H13.5a.5.5 0 0 0 0-1H2.207l2.146-2.147a.497.497 0 0 0 0-.706.5.5 0 0 0-.707 0z"}})])
          )
        }
      }
    